// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"MyAccount_paginationPageDropdownWrap__yo-hA","myAccount":"MyAccount_myAccount__wOZs8","rolesTitle":"MyAccount_rolesTitle__8+hcT"};